import React, { useContext } from "react";
import { useSelector } from "react-redux";

import { Model, ModelSelectors } from "@com.mgmtp.a12.client/client-core/lib/core/model";
import { OverviewEngineFactories } from "@com.mgmtp.a12.overviewengine/overviewengine-core/lib/main/client-extensions";
import { LocalizerContext } from "@com.mgmtp.a12.utils/utils-localization-react/lib/main";

import { createExternalEnumLocalizerContextValue } from "../utilities/externalEnumerationLocalizer";

export function ExternalEnumOverviewEngine(props: OverviewEngineFactories.ViewComponentProps) {
	const { activityId } = props;

	const store = useSelector(store => store);

	const documentModel = useSelector(
		ModelSelectors.modelInScene({ activityId: activityId, modelType: "document" }, Model.isDocumentModel)
	);

	const { locale } = useContext(LocalizerContext);

	// Use our custom external enum converter to make sure values of external enumerations are resolved
	const localizerContextValue = React.useMemo(
		() => createExternalEnumLocalizerContextValue(locale, store, documentModel),
		[documentModel, locale, store]
	);

	if (!localizerContextValue) {
		return <OverviewEngineFactories.ViewComponent {...props} />;
	}

	return (
		<LocalizerContext.Provider value={localizerContextValue}>
			<OverviewEngineFactories.ViewComponent {...props} />
		</LocalizerContext.Provider>
	);
}
